module.exports = __webpack_public_path__ + "img/spotify-brands.1abfa151.svg";